
import React from 'react';
import { useModalEffects } from '../hooks/useModalEffects';

interface InfoModalProps {
    onClose: () => void;
}

const InfoModal: React.FC<InfoModalProps> = ({ onClose }) => {
    useModalEffects(true, onClose, 'info-modal-content');

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-60 dark:bg-opacity-80 flex justify-center items-center z-50 p-4 transition-opacity duration-300"
            onClick={onClose}
        >
            <div 
                id="info-modal-content"
                className="card bg-white dark:bg-slate-800 p-6 rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto transform transition-all duration-300 ease-out opacity-0 scale-95"
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
            >
                <div className="flex justify-between items-center mb-4 pb-2 border-b border-gray-200 dark:border-gray-700">
                    <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">計分說明</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                
                <div className="text-gray-700 dark:text-gray-300 space-y-3 text-base">
                    <p className="font-bold text-lg text-indigo-700 dark:text-indigo-400">核心計分規則</p>
                    <ul className="list-decimal list-outside pl-5 space-y-2 marker:font-bold marker:text-gray-500">
                        <li>獲得<strong className="text-gray-900 dark:text-gray-100">中立卡牌</strong>或<strong className="text-gray-900 dark:text-gray-100">賽季卡</strong> +20pt。</li>
                        <li>獲得<strong className="text-gray-900 dark:text-gray-100">怪物卡</strong>根據稀有度：一般 +20pt、稀有 +50pt、傳說 +80pt。</li>
                        <li>所有卡片<strong className="text-gray-900 dark:text-gray-100">普閃</strong>皆不計分。</li>
                        <li>所有卡片獲得<strong className="text-gray-900 dark:text-gray-100">神閃</strong>，統一為 +20pt。</li>
                        <li><strong className="text-gray-900 dark:text-gray-100">複製卡片</strong>首 2 張不需點數，之後每 1 張計算為 +40pt，單一角色最多複製 3 次。</li>
                        <li>複製的卡片被移除，則該複製卡的計分點數退回，複製次數不退回。</li>
                        <li><strong className="text-gray-900 dark:text-gray-100">移除起始卡</strong> +20pt，此外的卡片移除不計算點數，單一角色移除最多 5 次。</li>
                    </ul>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700 text-right">
                    <button 
                        onClick={onClose}
                        className="px-6 py-2 bg-indigo-600 dark:bg-indigo-700/80 text-white font-semibold rounded-lg hover:bg-indigo-700 dark:hover:bg-indigo-600 transition-colors shadow-sm active:scale-95"
                    >
                        關閉
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
